import { useId, useState, type ReactNode } from 'react'
import { Sheet } from './States'

export function Field({
  label,
  hint,
  error,
  children,
}: {
  label: string
  hint?: ReactNode
  error?: string
  children: (props: { id: string; 'aria-invalid'?: boolean; 'aria-describedby'?: string }) => ReactNode
}) {
  const id = useId()
  const describedBy = [hint ? `${id}-hint` : '', error ? `${id}-error` : ''].filter(Boolean).join(' ') || undefined
  return (
    <div className="pc-field">
      <label htmlFor={id}>{label}</label>
      {children({ id, 'aria-invalid': error ? true : undefined, 'aria-describedby': describedBy })}
      {hint && (
        <div className="pc-field__hint" id={`${id}-hint`}>
          {hint}
        </div>
      )}
      {error && (
        <div className="pc-field__error" id={`${id}-error`}>
          {error}
        </div>
      )}
    </div>
  )
}

/**
 * Выход с несохранёнными изменениями спрашивает подтверждение (контракт S09).
 * guard(leave) вызывает leave сразу, если изменений нет.
 */
export function useLeaveGuard(dirty: boolean) {
  const [pending, setPending] = useState<(() => void) | null>(null)
  const guard = (leave: () => void) => {
    if (dirty) setPending(() => leave)
    else leave()
  }
  const dialog = pending ? (
    <Sheet title="Выйти без сохранения?" onClose={() => setPending(null)}>
      <p className="pc-muted" style={{ margin: '0 0 12px', fontSize: 14 }}>
        Изменения на этом экране ещё не сохранены и пропадут.
      </p>
      <button
        type="button"
        className="pc-btn pc-btn--block pc-btn--danger"
        onClick={() => {
          const leave = pending
          setPending(null)
          leave()
        }}
      >
        Выйти без сохранения
      </button>
      <button type="button" className="pc-btn pc-btn--block" onClick={() => setPending(null)}>
        Остаться
      </button>
    </Sheet>
  ) : null
  return { guard, dialog }
}
